/**
 * Quick Test target fields should track the live ROI/market reference until
 * the user manually edits them. After a manual edit, keep the user's value.
 */

/**
 * @param {{
 *   refValue: number|null|undefined,
 *   currentTarget: number|null|undefined,
 *   userEdited: boolean,
 *   lastSynced: number|null|undefined,
 * }} args
 * @returns {{ nextTarget: number|null, nextLastSynced: number|null, shouldUpdate: boolean }}
 */
export function nextAutoTarget({ refValue, currentTarget, userEdited, lastSynced }) {
  if (!refValue) {
    return { nextTarget: currentTarget || null, nextLastSynced: lastSynced ?? null, shouldUpdate: false };
  }
  const rounded = Math.round(refValue);

  // User typed a custom target — leave it alone (unless it still matches last sync).
  if (userEdited && currentTarget && currentTarget !== lastSynced) {
    return { nextTarget: currentTarget, nextLastSynced: lastSynced ?? null, shouldUpdate: false };
  }

  if (currentTarget === rounded) {
    return { nextTarget: rounded, nextLastSynced: rounded, shouldUpdate: false };
  }

  return { nextTarget: rounded, nextLastSynced: rounded, shouldUpdate: true };
}
